import React from 'react';
import ProyectosComponent from './Proyectos';

const Proyectos = () => {

    //validations
    const validationMessages = {
        techName: [
            {
                type: 'required',
                message: 'Favor ingresar el nombre de la tecnolog�a',
            },
        ],
    }

    return (
        <div>
            <ProyectosComponent validationMessages={validationMessages} />
        </div>
    );
};

export default Proyectos;